import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Time from "../../Time/Time";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Translator from "../../Translation/Translator";

export default function* contractEnd(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_END_REQUEST
    });
    const res = yield call(Http.put, `contract/${action.payload?.contractId}/end`, {
      endDate: Time.formatOrNull(action.payload?.endDate)
    });
    const contract: ContractInterface = ContractFactory.create(res.data.data.contract);
    yield put({
      type: Constants.GLOBAL_CONTRACT_END_SUCCESS,
      payload: {
        contract: contract
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-contract-end-date-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_END_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractEnd() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_END_START, contractEnd);
}
